import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  NgbNavModule,
  NgbAccordionModule,
  NgbDropdownModule,
  NgbModule,
} from "@ng-bootstrap/ng-bootstrap";
import { SwiperModule } from "ngx-swiper-wrapper";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { CountToModule } from "angular-count-to";
import { BreadcrumbsComponent } from "./breadcrumbs/breadcrumbs.component";
import { ScrollspyDirective } from "./scrollspy.directive";
import { ToastrModule } from "ngx-toastr";
import { ValidationMessageToasterComponent } from "./http-Interceptors/validation-message-toaster/validation-message-toaster.component";
import { FilePickerComponent } from "./file-picker/file-picker.component";
import { AttachmentPreviewModelComponent } from "./attachment-preview-model/attachment-preview-model.component";
import { FormsModule } from "@angular/forms";
import { RequestValidationComponent } from "./request-validation/request-validation.component";
import { RequestValidationService } from "./request-validation/request-validation.service";
import { UnsavedChanges } from "./unsaved-changes/unsaved-changes.component";
import { HttpClientModule } from "@angular/common/http";
import { ImagePickerComponent } from "./image-picker/image-picker.component";
import { TabLinkComponent } from "./tabs/tab-link.component";
import { TabsComponent } from "./tabs/tabs.component";
import { RouterModule } from "@angular/router";
import { httpInterceptorProviders } from "./http-Interceptors";
import { StateManagementService } from "./state-management/state-management.service";
import { InputTrimModule } from 'ng2-trim-directive';
import { GridRefreshService } from "./grid-refresh.service";
import { UnderWriterComponent } from "./lookups/underwriter/underwriter.component";
import { BrokerComponent } from "./lookups/broker/broker.component";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { DataTablePagerComponent } from "./data-table/pager.component";
import { UnderWriterLirmaComponent } from "./lookups/underwriter-lirma/underwriter-lirma.component";
import { ClientAccontPaymentComponent } from "./lookups/client-account-payment/clientAccountPayment.component";
import { ClientPaymentComponent } from "./lookups/client-payment/clientPayment.component";
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { DecimalInputDirective } from "./decimal-input-directve";
import { PercentInputDirective } from "./percent-input.directive";
import { NumberFormatDirective } from "./number-format.directive";
import { DateValidationDirective } from "./date-validation.directive";
import { GroupInvoicesTableComponentLookup } from "./lookups/group-invoices-table/group-invoices-table.component";

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: "horizontal",
  slidesPerView: "auto",
};

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    ScrollspyDirective,
    FilePickerComponent,
    AttachmentPreviewModelComponent,
    ValidationMessageToasterComponent,
    RequestValidationComponent,
    UnsavedChanges,
    ImagePickerComponent,
    TabLinkComponent,
    TabsComponent,
    UnderWriterComponent,
    UnderWriterLirmaComponent,
    GroupInvoicesTableComponentLookup,
    BrokerComponent,
    DataTablePagerComponent,
    ClientAccontPaymentComponent,
    ClientPaymentComponent,
    DecimalInputDirective,
    PercentInputDirective,
    NumberFormatDirective,
    DateValidationDirective
  ],
  imports: [
    CommonModule,
    NgbNavModule,
    RouterModule,
    HttpClientModule,
    NgbAccordionModule,
    NgbDropdownModule,
    SwiperModule,
    BsDatepickerModule.forRoot(),
    FormsModule,
    CountToModule,
    ToastrModule.forRoot({ toastComponent: ValidationMessageToasterComponent }),
    InputTrimModule,
    NgbModule,
    NgxDatatableModule,
    PerfectScrollbarModule
  ],
  exports: [
    BreadcrumbsComponent,
    ScrollspyDirective,
    FilePickerComponent,
    RequestValidationComponent,
    UnsavedChanges,
    ImagePickerComponent,
    TabsComponent,
    InputTrimModule,
    UnderWriterComponent,
    UnderWriterLirmaComponent,
    BrokerComponent,
    DataTablePagerComponent,
    DecimalInputDirective,
    PercentInputDirective,
    NumberFormatDirective,
    DateValidationDirective
  ],
  providers: [
    RequestValidationService,
    FilePickerComponent,
    BsDatepickerConfig,
    httpInterceptorProviders,
    StateManagementService,
    GridRefreshService,
  ],
  entryComponents: [
    ValidationMessageToasterComponent,
    AttachmentPreviewModelComponent,
    UnderWriterComponent,
    GroupInvoicesTableComponentLookup,
    UnderWriterLirmaComponent,
    BrokerComponent
  ]
})
export class SharedModule {}
